import { workShiftClockActionEnum } from '@gozoki/api-types'
import { useQuery } from '@tanstack/react-query'
import { api } from '~/lib/tuyau'
import { createFileRoute } from '@tanstack/react-router'
import { DateTime } from 'luxon'
import { useState } from 'react'
import z from 'zod'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { WorkshiftAttendanceHistoryDialog } from '~/components/routes/workshift-attendance/workshift-attendance-history-dialog'
import { WorkShiftAttendanceLog } from '~/components/routes/workshift-attendance/workshift-attendance-log'
import { Button } from '~/components/ui/button'

export const Route = createFileRoute('/_nosidebar/workshift-attendance/$storeId')({
  component: RouteComponent,
  validateSearch: z.object({
    collaboratorId: z.number().optional(),
    action: z.enum(workShiftClockActionEnum).optional(),
  }),
  params: {
    parse: z.object({ storeId: z.coerce.number() }).parse,
  },
})

function RouteComponent() {
  const { storeId } = Route.useParams()
  const [isHistoryOpen, setIsHistoryOpen] = useState(false)

  const { data: store, isLoading: isLoadingStore } = useQuery(
    api.stores.show.queryOptions({ params: { id: storeId } }),
  )
  const now = DateTime.now()

  if (isLoadingStore && !store) {
    return <div>Chargement...</div>
  }

  if (!store) {
    return <div>Boutique non trouvée</div>
  }

  return (
    <div className="p-2 h-dvh flex flex-col">
      <AppHeader>
        <Title
          subtitle={`${now.toLocaleString(DateTime.DATE_HUGE)} • ${now.toLocaleString(DateTime.TIME_24_SIMPLE)}`}
        >
          {store.label}
        </Title>

        <Button
          variant="outline"
          className="ml-auto text-lg"
          size="lg"
          onClick={() => setIsHistoryOpen(true)}
        >
          Historique
        </Button>
      </AppHeader>

      <AppContainer>
        <WorkShiftAttendanceLog storeName={store.label} storeId={storeId} />
      </AppContainer>

      <WorkshiftAttendanceHistoryDialog
        open={isHistoryOpen}
        onOpenChange={setIsHistoryOpen}
        storeId={storeId}
        storeName={store.label}
      />
    </div>
  )
}
